module.exports = __webpack_public_path__ + "assets/images/01L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01L-route-sheet.png
// module id = 1255
// module chunks = 1